import type { AppRole } from "./authApi";

const ROLE_CACHE_PREFIX = "tf_app_role:";

function isAppRole(value: string | null): value is AppRole {
  return value === "admin" || value === "superadmin";
}

export function readCachedRole(uid: string | null | undefined): AppRole | null {
  if (!uid) return null;
  try {
    const raw = window.localStorage.getItem(`${ROLE_CACHE_PREFIX}${uid}`);
    return isAppRole(raw) ? raw : null;
  } catch {
    return null;
  }
}

export function writeCachedRole(uid: string, role: AppRole): void {
  try {
    window.localStorage.setItem(`${ROLE_CACHE_PREFIX}${uid}`, role);
  } catch {
    // Ignore quota / private-mode failures; nav still works after /api/me.
  }
}

export function clearCachedRole(uid: string | null | undefined): void {
  if (!uid) return;
  try {
    window.localStorage.removeItem(`${ROLE_CACHE_PREFIX}${uid}`);
  } catch {
    // no-op
  }
}
